<template>
  <div class="content">
    <!-- page title -->
    <div class="content-header">
      <h3>{{ title.key }}</h3>
    </div>
    <!-- paginate -->
    <paginate 
      class="videos-list"
      name="videoPaginated"
      :list="videos_list"
      :per="9"
      :refreshCurrentPage="true">
      <div 
        class="box-video"
        :class="{
          'box-video': true,
          'column': !item.Director
        }"
        v-for="(item,i) in paginated('videoPaginated')"
        :key="i">
        <!-- router -->
        
          <!-- @click -->
          <div class="cursor-fixed">
            <span>
              <!-- image -->
              <router-link
                :to="`/${lng}/videos/${$route.params.type}/${item.ID}`">
                <div class="video-img"
                  :style="{
                    backgroundImage:'url('+file(item.ImageLink)+')'
                  }"></div>
              </router-link>
              <ul 
                v-if="item.Director">
                <li><span>Yıl :</span>{{ item.Year}}</li>
                <li><span>Yönetmen :</span>{{item.Director}}</li>
              </ul>
            </span>
            <div class="video-info-content">
              <div class="video-title">
                <router-link
                  :to="`/${lng}/videos/${$route.params.type}/${item.ID}`">
                  <span>{{item.Key}}</span>
                </router-link>
                <div
                  v-if="item.Director" class="director"
                  v-html="item.Contents"></div>
              </div>
            </div>
          </div>
        
      </div>
    </paginate>
    <paginate-links 
      for="videoPaginated" 
      :limit="3" 
      :show-step-links="true" 
      :hide-single-page="true"></paginate-links>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  props: ['menu'],
  data() {
    return {
      paginate: ['videoPaginated']
    };
  },
  computed: {
    ...mapGetters(['videos_list', 'file', 'lng']),
    title() {
      return this.menu;
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../styles/colors';
.video-item-content-wrapper {
  padding: 10px;
  h3 {
    color: $main;
    padding: 0 10px;
    font-size: 17px;
    text-align: center;
  }
  .close {
    text-align: right;
    .closed-modal {
      cursor: pointer;
      padding: 5px;
      font-weight: bold;
      color: #8c8c8c;
      &:hover {
        color: #222;
      }
    }
  }
  .video-frame {
    position: relative;
    padding-bottom: 56.25%;
    /* 16:9 */
    padding-top: 25px;
    height: 0;
    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
    }
  }
}

.content {
  line-height: 26px;
  color: #444;
  p {
    text-align: left;
  }
}

.cursor-fixed {
  text-align: center;
}

.videos-list {
  margin-top: 20px;
  display: flex;
  flex-wrap: wrap;
  .box-video {
    padding: 10px;
    margin-bottom: 20px;
    width: 100%;
    .cursor-fixed {
      display: flex;
    }
    a {
      display: block;
      width: 100%;
    }
    &:not(:last-child) {
      border-bottom: 1px solid rgba(150, 150, 150, 0.44);
    }
    ul {
      width: 170px;
      text-align: left;
      padding: 10px 0;
      font-size: 14px;
      li {
        line-height: 15px;
        margin-bottom: 5px;
        span {
          color: $main;
          margin-right: 4px;
        }
      }
    }
    &.column {
      align-items: center;
      display: flex;
      flex-direction: column;
      border: none;
      @media screen and (min-width: 480px) {
        width: 50%;
      }
      @media screen and (min-width: 762px) {
        width: 33.33333%;
      }
      .video-img {
        margin: 0 auto;
      }
      .cursor-fixed {
        display: block;
      }
      .video-title {
        flex: 1;
        text-align: center;
        span {
          border: 2px solid transparent;
          border-top-color: #949195;
          border-bottom-color: #949195;
          padding: 3px 5px;
          color: #333;
          font-size: 13px;
        }
      }
      .video-info-content {
        padding: 10px;
      }
    }
    .director {
      padding: 10px 0;
      font-size: 13px;
      text-indent: 10px;
      text-align: justify;
    }
    .video-info-content {
      flex: 1;
      text-align: left;
      padding: 0 20px;
    }
    .video-img {
      cursor: pointer;
      width: 145px;
      height: 145px;
      background-position: center center;
      background-size: cover;
      background-repeat: no-repeat;
      border: 8px solid #fff;
      box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.3);
    }
    .video-title {
      padding: 0 10px 10px;
      span {
        display: inline-block;
        font-size: 15px;
        cursor: pointer;
        line-height: 18px;
        color: $main;
      }
    }
  }
}
</style>